export default __webpack_public_path__ + "static/media/ContactCentres.0290559f.pdf";